module.exports = __webpack_public_path__ + "index_pc/img/name_4-5.d3209088.png";